export function waitForSelector(
  selector: string,
  intervalMs: number,
  timeoutMs: number
): Promise<Element | null> {
  if (intervalMs <= 0) {
    return Promise.resolve(document.querySelector(selector))
  }

  return new Promise((resolve) => {
    const started = Date.now()

    const tick = () => {
      const element = document.querySelector(selector)
      if (element) {
        resolve(element)
        return
      }
      if (Date.now() - started >= timeoutMs) {
        console.warn(`[BppSearch] Trigger not found: ${selector}`)
        resolve(null)
        return
      }
      window.setTimeout(tick, intervalMs)
    }

    tick()
  })
}
